// eslint-disable-next-line @nx/enforce-module-boundaries
import { isBrowser, getSearchParams, appPath } from '@web3/base-utils';
import { useRouter } from 'next/router';

export const useParams = (): Record<string, string> => {
  const { query } = useRouter();

  if (isBrowser) {
    const searchParams = getSearchParams();

    return {
      ...searchParams,
      ...query,
    } as Record<string, string>;
  }

  return query as Record<string, string>;
};

export const useSetParams = () => {
  const { locale } = useParams();
  const setSearchParams = (params) => {
    if (isBrowser) {
      window.history.replaceState(
        null,
        '',
        `${window.location.origin}/${locale}${appPath}${params.length ? `?${params?.toString()}` : ''}`
      );
    }
  };

  return { setSearchParams };
};

export const useNavigate = () => {
  const { locale } = useParams();

  // 同应用之间的pc相关跳转，内部自动拼接了多语言和appPath，并使用window.open打开页面
  const navigateToPcPage = (
    pagePath: string,
    target: '_self' | '_blank' | '_parent' | 'top' = '_blank'
  ) => {
    window.open(`/${locale}${appPath}${pagePath}`, target);
  };

  return {
    navigateToPcPage,
  };
};
